import { CalendarEvent } from '@/types/community';
import dayjs from 'dayjs';

function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  return dayjs().add(daysOffset, 'days').hour(hour).minute(minute).second(0).millisecond(0).toDate();
}

function getRelativeDateRange(startDaysOffset: number, endDaysOffset: number, startHour: number = 9, startMinute: number = 0, endHour: number = 17, endMinute: number = 0): { start: Date; end: Date } {
  return {
    start: getRelativeDate(startDaysOffset, startHour, startMinute),
    end: getRelativeDate(endDaysOffset, endHour, endMinute)
  };
}

export const events: CalendarEvent[] = [
  // Past events (last month)
  {
    id: 'EVT001',
    title: 'Reunião da Comunidade',
    description: 'Reunião mensal da comunidade para discutir assuntos importantes.',
    ...getRelativeDateRange(-45, -45, 18, 0, 20, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT002',
    title: 'Manutenção da Piscina',
    description: 'Manutenção programada da piscina e limpeza.',
    ...getRelativeDateRange(-40, -40, 9, 0, 12, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP003',
      name: 'Equipe de Manutenção',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT003',
    title: 'Treinamento de Segurança',
    description: 'Sessão de treinamento para equipe de segurança.',
    ...getRelativeDateRange(-35, -35, 14, 0, 16, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP004',
      name: 'Supervisor de Segurança',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT004',
    title: 'Reunião do Clube do Livro',
    description: 'Discussão mensal do clube do livro.',
    ...getRelativeDateRange(-30, -30, 18, 30, 20, 0),
    type: 'activity',
    hostedBy: {
      id: 'RES002',
      name: 'Joana Silva',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT005',
    title: 'Simulado de Emergência',
    description: 'Simulado mensal de evacuação de emergência.',
    ...getRelativeDateRange(-25, -25, 15, 0, 16, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP004',
      name: 'Supervisor de Segurança',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Current month events (this month)
  {
    id: 'EVT006',
    title: 'Aula de Yoga',
    description: 'Sessão semanal de yoga para todos os residentes.',
    ...getRelativeDateRange(-15, -15, 7, 0, 8, 30),
    type: 'activity',
    hostedBy: {
      id: 'EMP002',
      name: 'Instrutor de Fitness',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT007',
    title: 'Hora Social dos Residentes',
    description: 'Encontro social mensal para residentes se conhecerem e socializarem.',
    ...getRelativeDateRange(-10, -10, 19, 0, 21, 0),
    type: 'activity',
    hostedBy: {
      id: 'RES001',
      name: 'João Silva',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT008',
    title: 'Instalação de Equipamentos da Academia',
    description: 'Instalação e configuração de novos equipamentos da academia.',
    ...getRelativeDateRange(-5, -5, 8, 0, 17, 0),
    type: 'other',
    hostedBy: {
      id: 'VEN001',
      name: 'Empresa de Equipamentos Fitness',
      type: 'vendor'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT009',
    title: 'Reunião do Conselho',
    description: 'Reunião mensal do conselho para discutir assuntos da comunidade.',
    ...getRelativeDateRange(-2, -2, 16, 0, 18, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT010',
    title: 'Aulas de Natação',
    description: 'Aulas de natação para crianças.',
    ...getRelativeDateRange(-1, -1, 10, 0, 11, 30),
    type: 'activity',
    hostedBy: {
      id: 'EMP005',
      name: 'Instrutor de Natação',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Future events (next few days)
  {
    id: 'EVT011',
    title: 'Churrasco da Comunidade',
    description: 'Churrasco anual da comunidade no pátio.',
    ...getRelativeDateRange(2, 2, 12, 0, 18, 0),
    type: 'activity',
    hostedBy: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT012',
    title: 'Avaliação de Fitness',
    description: 'Avaliação gratuita de fitness para todos os residentes.',
    ...getRelativeDateRange(5, 5, 9, 0, 17, 0),
    type: 'activity',
    hostedBy: {
      id: 'EMP002',
      name: 'Instrutor de Fitness',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT013',
    title: 'Revisão de Manutenção',
    description: 'Reunião trimestral de revisão de manutenção.',
    ...getRelativeDateRange(8, 8, 14, 0, 16, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP003',
      name: 'Equipe de Manutenção',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT014',
    title: 'Noite do Cinema',
    description: 'Exibição de filme ao ar livre no pátio.',
    ...getRelativeDateRange(10, 10, 19, 30, 22, 0),
    type: 'activity',
    hostedBy: {
      id: 'RES003',
      name: 'Miguel Johnson',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT015',
    title: 'Atualização do Sistema de Segurança',
    description: 'Atualização e teste do sistema de segurança.',
    ...getRelativeDateRange(12, 12, 8, 0, 16, 0),
    type: 'other',
    hostedBy: {
      id: 'VEN002',
      name: 'Sistemas de Segurança Inc.',
      type: 'vendor'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Next month events
  {
    id: 'EVT016',
    title: 'Decorações de Feriado',
    description: 'Instalação de decorações de feriado em toda a comunidade.',
    ...getRelativeDateRange(25, 25, 9, 0, 17, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP003',
      name: 'Equipe de Manutenção',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT017',
    title: 'Planejamento da Festa de Ano Novo',
    description: 'Reunião de planejamento para celebração de Ano Novo.',
    ...getRelativeDateRange(30, 30, 18, 0, 20, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT018',
    title: 'Fechamento da Piscina no Inverno',
    description: 'Fechamento anual da piscina no inverno e manutenção.',
    ...getRelativeDateRange(35, 35, 8, 0, 16, 0),
    type: 'other',
    hostedBy: {
      id: 'EMP003',
      name: 'Equipe de Manutenção',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT019',
    title: 'Pesquisa dos Residentes',
    description: 'Distribuição da pesquisa anual de satisfação dos residentes.',
    ...getRelativeDateRange(40, 40, 10, 0, 18, 0),
    type: 'activity',
    hostedBy: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'EVT020',
    title: 'Reunião de Revisão do Orçamento',
    description: 'Reunião anual de revisão e planejamento do orçamento.',
    ...getRelativeDateRange(45, 45, 14, 0, 17, 0),
    type: 'meeting',
    hostedBy: {
      id: 'EMP001',
      name: 'Gerente da Comunidade',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 